/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/
import { Pipe, PipeTransform } from '@angular/core';

import { LocoIncident } from '../shared/model/loco-incident.model';

/**
 * @export
 * @class LocoProblemSortPipe
 * @implements {PipeTransform}
 */
@Pipe({
    name: 'locoProblemSort',
    pure: false
})

export class LocoProblemSortPipe implements PipeTransform {

    /**
     * This Method is used to set the priority for Bands based on incident Type
     * @param {string} incidentType
     * @returns {number}
     * @memberOf LocoProblemSortPipe
     */
    getPriority(incidentType: string): number {
        if ('D' === incidentType.toUpperCase()) {
            return 1;
        } else {
            return 2;
        }

    }

    /**
     * This is used to sort the problems based on indident type and timestamp
     * @param {Array<LocoIncident>} incidents
     * @returns {Array<LocoIncident>}
     * @memberOf LocoProblemSortPipe
     */
    transform(incidents: Array<LocoIncident>): Array<LocoIncident> {
        if (!incidents) {
            return incidents;
        }
        incidents.sort((a: LocoIncident, b: LocoIncident) => {
            if (this.getPriority(a.incidentType) < this.getPriority(b.incidentType)) {
                return -1;
            }
            if (this.getPriority(a.incidentType) > this.getPriority(b.incidentType)) {
                return 1;
            }
            if (this.getPriority(a.incidentType) === this.getPriority(b.incidentType)) {
                if (new Date(a.incidentDate) > new Date(b.incidentDate)) {
                    return -1;
                } else if (new Date(a.incidentDate) < new Date(b.incidentDate)) {
                    return 1;
                } else {
                    return 0;
                }

            }
        });
        return incidents;
    }
}
